module.exports = __webpack_public_path__ + "img/hazardCategory1.f581fb23.png";